'use client';
import Image from 'next/image';
import { ModalSelect } from './_components/select';
import { useState } from 'react';

import { useRouter } from 'next/navigation';

interface ModalTwoProps {
  isOpen: boolean;
  onClose: () => void;
}

type Option = {
  label: string;
  value: string;
  group?: string;
};

const BUSINESS_GROUP = 'PARA SUA EMPRESA';
const PERSONAL_GROUP = 'PARA VOCÊ';

const services: Option[] = [
  {
    label: 'CAIXA Alimentação',
    value: 'https://loja.caixaprepagos.com.br/?',
    group: BUSINESS_GROUP,
  },
  {
    label: 'CAIXA Refeição',
    value: 'https://loja.caixaprepagos.com.br/#',
    group: BUSINESS_GROUP,
  },
  {
    label: 'CAIXA Multi',
    value: 'https://loja.caixaprepagos.com.br/',
    group: BUSINESS_GROUP,
  },
  { label: 'vtCAIXA', value: 'vtcaixa', group: BUSINESS_GROUP },
  { label: 'frotaCAIXA', value: 'frotacaixa', group: BUSINESS_GROUP },
  {
    label: 'tagCAIXA Empresas',
    value: 'tagcaixa',
    group: BUSINESS_GROUP,
  },
  {
    label: 'tagCAIXA',
    value: 'https://ecommerce.caixaprepagos.com.br',
    group: PERSONAL_GROUP,
  },
];

export default function ServicesModal({ isOpen, onClose }: ModalTwoProps) {
  const [selectedHref, setSelectedHref] = useState('');
  const router = useRouter();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="relative w-full max-w-2xl rounded-lg p-6">
        {/* Botão de fechar */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 w-10 h-10 rounded-lg bg-white hover:bg-gray-100 shadow-md flex items-center justify-center"
          aria-label="Fechar modal"
        >
          <Image
            src={'/icons/x-circle.png'}
            alt="Close modal"
            height={26}
            width={26}
          />
        </button>
        <div className="bg-white w-full max-w-2xl rounded-lg shadow-lg p-6">
          {/* Parte 1 */}
          <div className="mb-6">
            <h2 className="text-blue-600 text-xl font-bold">
              Serviços CAIXA Pré-Pagos
            </h2>
            <p className="text-gray-600 mt-2">
              Conheça os serviços disponíveis e escolha como deseja contratar:
              online ou com o suporte da nossa equipe.
            </p>
          </div>

          {/* Parte 2 */}
          <div className="space-y-4 mb-6">
            <ModalSelect services={services} onChange={setSelectedHref} />
          </div>

          {/* Parte 3 */}
          <div className="flex flex-col gap-3 items-end">
            <button
              className="flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-4 py-4 rounded w-full"
              onClick={() => {
                if (selectedHref !== '') {
                  router.push(selectedHref);
                }
              }}
            >
              <Image
                src="/icons/arrow-right-circle.png"
                alt="Seta"
                width={20}
                height={20}
              />
              CONTINUAR
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
